import {signOut} from "firebase/auth";
import {useLoaderData, useNavigate} from "react-router-dom";
import {sendPasswordResetEmail} from "firebase/auth";
import {useLocation} from "react-router-dom";
import Button from '@mui/material/Button';

import {LOG_TYPES, HISTORY_USER} from "ultra/const/log";
import {getClientCity} from 'ultra/configs/general';
import {isEmptyObj} from 'ultra/helpers/utils';
import {isAdmin} from 'ultra/helpers/auth';

import LogoutIcon from '@mui/icons-material/Logout';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PasswordIcon from '@mui/icons-material/Password';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import TelegramIcon from '@mui/icons-material/Telegram';
import Grid from '@mui/material/Grid';

import {useNavigationStore} from '../../../../Stores/navigation';
import {useFirebaseStore} from '../../../../Stores/firebase';
import {useNotifyStore} from '../../../../Stores/notify';

import {useToasterStore} from '../../../../Stores/toster';
import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';

import PreloaderForm from '../../../../Components/Preloaders/PreloaderForm';
import UserLibraryList from '../../Components/UserLibraryList';
import UserSingeltonesList from '../../Components/UserSingeltonesList';
import UserNodesList from '../../Components/UserNodesList';
import ProfileActions from '../../Components/ProfileActions';

import Avatar from '../../../Content/Widgets/Avatar';

import {getNodeContent} from '../../../../Helpers/content';
import {userHasAllNodes} from '../../../../Helpers/user';
// import MessengerValue from '../../../Content/Widgets/MessengerValue';
import {useGlobalCustomContext} from '../../../../Helpers/context';

import {saveUserHistoryAndNotify, userTelegramUntie} from '../../../Profile/Helpers/user';
import {userLogout} from '../../../Profile/Helpers/user';

import {USER_ACTIONS} from '../../../Profile/Reducers/user';

import './index.scss';

export default (props) => {
    const {hideNavigation} = props

    const {contentLoading} = useNavigationStore()
    const {auth} = useFirebaseStore();
    const {showNotify} = useNotifyStore();

    const navigate = useNavigate();
    const user = useLoaderData();
    const location = useLocation();

    const {userState, userDispatch} = useGlobalCustomContext();

    const {showError} = useToasterStore();
    const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore()

    let hasSingelton = false
    if (user?.nodes?.singleton) {
        Object.keys(user.nodes.singleton).map(city => {
            if (!isEmptyObj(user.nodes.singleton[city])) hasSingelton = true
        })
    }

    if (contentLoading || !user) return <PreloaderForm />

    function onGoBack() {
        navigate('/')
    }

    function goToMessages(id) {
        navigate('/telegram/messages/' + id)
    }

    function goToLogs(id) {
        navigate('/telegram/logs/' + id)
    }

    function goToChats(id) {
        navigate('/telegram/chats/' + id)
    }

    const onEditProfile = () => {
        userDispatch({type: USER_ACTIONS.PROFILE_EDIT})
    }

    const onNotificationsClick = () => {
        userDispatch({type: USER_ACTIONS.TG_NOTIFY_EDIT})
    }

    // TODO: make one function / has duplicate
    const onChangePassword = () => {
        if (userState?.user.emailNotVerified) {
            showError({
                snackbarMessage: 'Для зміни паролю, необхідно підтвердити ваш email',
            })
            return;
        }
    
        showBackdropPreloader();
    
        // TODO: make similar to email validation
            // save flag
            // and move logs and history to backend

        if (!userState?.user?.email) return;

        sendPasswordResetEmail(auth, userState.user.email)
            .then(async () => {
                showNotify({text: 'На вашу електронну адресу було направлено посилання для зміни паролю'});
    
                await saveUserHistoryAndNotify(userState.user.email, LOG_TYPES.INFO, HISTORY_USER.PASSWORD_UPDATE_REQUEST_EMAIL_SUCCESS);
            })
            .catch(async err => {
                console.log(err)
                if (err.code === 'auth/invalid-email') {
                    showError({
                        snackbarMessage: `${userState.user.email} - не коректний email`
                    });
                } else {
                    showError({
                        snackbarMessage: 'Виникла помилка, спробуйте пізніше'
                    });
                }
    
                await saveUserHistoryAndNotify(userState?.user?.email, LOG_TYPES.ERROR, HISTORY_USER.PASSWORD_UPDATE_REQUEST_EMAIL_ERROR, err);
            })
    }

    const signOutHandler = () => {
        showBackdropPreloader();
    
        // TODO: make one function / has duplicate
        userLogout()
          .promise
          .then(async () => {
              signOut(auth);
    
              userDispatch({type: USER_ACTIONS.USER_REMOVE});
    
              hideBackdropPreloader();
    
              const isProfilePage = location.pathname.indexOf('/profile') === 0
    
              if (isProfilePage) {
                navigate('/');
              }
              else {
                const city = getClientCity(window);
                
                try {
                  await getNodeContent({
                    city,
                    uri: location.pathname // revertPath()
                  }).promise
    
                  navigate(location.pathname + location.search);
                }
                catch (e) {
                  navigate('/');
                }
              }
    
              window.localStorage.removeItem("verify-email-msg-displayed");
          })
          .catch(() => {
            userDispatch({type: USER_ACTIONS.USER_REMOVE});
          })
    }

    return <div className='ProfilePage'>
        <Avatar image={user?.photoURL} roles={user?.roles} />

        <div className="userDetails">
            <div className="pageTopTitle">
                <div className="pageTopTitleText">                    
                    <ChevronLeftIcon className="goBack" onClick={onGoBack} />

                    <span className='pageTitle'>
                        {user?.displayName}
                    </span>
                </div>
            </div>

            {user?.email && <div className='userEmail'>
                {user.email}
            </div>}

            {!hideNavigation && <div className='UserActions'>
                <TelegramIcon onClick={onNotificationsClick} />
                <DriveFileRenameOutlineOutlinedIcon  onClick={onEditProfile} />
                <PasswordIcon onClick={onChangePassword} />
            </div>}

            {/* <div className='actionButtons'> */}
                {/* <NotificationsIcon alt="Сповіщення / Підписка" /> */}
                {/* <BookmarkIcon alt="Обране" /> */}
                {/* <EmailIcon alt="Повідомлення" /> */}
            {/* </div> */}
            
            {/* <div className='userDetails'>
                {user?.facebook && <p className='labelWrap'>
                    <span className="label">Facebook:</span>
                    <span className="labelValue">
                        <Link blank link={getFacebookLink(user?.facebook)} />
                    </span>
                </p>}
                {user?.instagram && <p className='labelWrap'>
                    <span className="label">Instagram:</span>
                    <span className="labelValue">
                        <Link blank link={getInstagramLink(user?.instagram)} />
                    </span>
                </p>}
            </div> */}
        </div>

        <Grid container spacing={2}>

            {user?.creationTime && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    <span className='label'>Зареєстровано:</span>
                    <span className='labelValue'>
                        {user?.creationTime}
                    </span>
                </div>
            </Grid>}

            {user?.emailNotVerified > 0 && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    {/* <span className='label'>Бібліотека:</span> */}
                    <span className='labelValue'>
                        ❗️ Email не підтверджено
                    </span>
                </div>
            </Grid>}

            {user?._blocked > 0 && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    {/* <span className='label'>Бібліотека:</span> */}
                    <span className='labelValue'>
                        ⛔️ Заблоковано на Простір
                    </span>
                </div>
            </Grid>}

            {user?.roles && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    <span className='label'>Ролі:</span>
                    <span className='labelValue'>
                        {user?.roles?.join(', ')}
                    </span>
                </div>
            </Grid>}

            {user.facebook && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    <span className='label'>Facebook:</span>
                    <span className='labelValue'>
                        {user.facebook}
                    </span>
                </div>
            </Grid>}

            {user.instagram && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    <span className='label'>Instagram:</span>
                    <span className='labelValue'>
                        {user.instagram}
                    </span>
                </div>
            </Grid>}

            {user?.nodes && userHasAllNodes(user.nodes) > 0 && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    <span className='label'>Створений контент:</span>
                    <span className='labelValue'>
                        <UserNodesList list={user.nodes?.all}/>
                    </span>
                </div>
            </Grid>}

            {hasSingelton && Object.keys(user.nodes?.singleton).length > 0 && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>
                    <span className='label'>Singleton:</span>
                    <span className='labelValue'>
                        <UserSingeltonesList list={user.nodes?.singleton}/>
                    </span>
                </div>
            </Grid>}

            {/* TODO: fix */}
            {(user?.library?.length > 0 || user?.library_stat)
                && Number(user?.library_stat?.bali?.amount) > 0
                && <Grid item xs={12}>
                    <div className='labelWrap labelWrapRow'>
                        <span className='label'>Бібліотека:</span>
                        {user?.library?.length > 0 && <span className='labelValue'>
                            <UserLibraryList list={user?.library} />
                        </span>}
                        {user?.library_stat?.bali?.amount && user?.library_stat?.bali?.amount > 0 && <span className='labelValue'>
                            Прочитано {user.library_stat.bali.amount} книг
                        </span>}
                    </div>
                </Grid>}

            {user?.chats && <Grid item xs={12}>
                <div className='labelWrap labelWrapRow'>

                    <span className='label'>Активність у чатах:</span>
                    
                    {user?.chats?._banned && <span className='labelValue'>
                        ⛔️ Користувач заблокований
                    </span>}

                    {user?.chats?._muted && <span className='labelValue'>
                        🔕 Користувач замьчений
                    </span>}

                    {user?.chats?.amount && <span className='labelValue'>
                        {user.chats.amount} чатів
                    </span>}

                    {user?.chats?.messages && <span className='labelValue'>
                        {user.chats.messages} повідомлень
                    </span>}

                    {/* {user?.chats?.messages && <span className='labelValue'>
                        <span className='pseudoLink' onClick={() => goToMessages(user.chats.telegram_id)}>{user.chats.messages}</span> повідомлень
                    </span>} */}

                    {user?.chats?.username && <span className='labelValue sendTGMessage'>
                        <Button fullWidth variant="outlined" href={`https://t.me/${user.chats.username}`}>Написати в телеграм</Button>
                    </span>}

                    {!user?.chats?.username && user?.chats?.telegram_id && <span className='labelValue sendTGMessage'>
                        <Button fullWidth variant="outlined" href={`tg://user?id=${user.chats.telegram_id}`}>Написати в телеграм</Button>
                    </span>}


                    {isAdmin(userState?.user) && <div className="AdminTelegramActions">
                        {user?.chats?.messages && <div>
                            <span className='pseudoLink' onClick={() => goToMessages(user.chats.telegram_id)}>Повідомлення</span>
                        </div>}
                        {user?.chats?.amount && <div>
                            <span className='pseudoLink' onClick={() => goToChats(user.chats.telegram_id)}>Чати</span>
                        </div>}
                        <div>
                            <span className='pseudoLink' onClick={() => goToLogs(user.chats.telegram_id)}>Лог</span>
                        </div>
                    </div>}

                </div>
            </Grid>}

            {user.telegram_id && <Grid item xs={12}><div className='pseudoButton' onClick={async () => {await userTelegramUntie(); navigate(0)}}>Відв'язати телеграм {user.telegram_id}</div></Grid>}

            <Grid item xs={12}>
                <Button
                    fullWidth
                    color="error"
                    startIcon={<LogoutIcon />}
                    variant="outlined"
                    onClick={signOutHandler}
                >
                    Вийти
                </Button>
            </Grid>

        </Grid>

        <ProfileActions hideProfile />
    </div>
}